import { WritableSignal } from '@angular/core';
import { AbstractControl } from '@angular/forms';

/**
 * Extracts validation error messages from ASP.NET Core 400 error response
 * 
 * @param err The HTTP error response
 * @returns Array of error messages, or empty array if no validation errors found
 */
export function extractValidationErrors(err: any): string[] {
    if (err.status === 400 && err.error?.errors) {
        const errors: string[] = [];
        // err.error.errors is an object like { "FieldName": ["error1", "error2"] }
        Object.values(err.error.errors).forEach((fieldErrors: any) => {
            if (Array.isArray(fieldErrors)) {
                errors.push(...fieldErrors);
            }
        });
        return errors;
    }
    return [];
}

/**
 * Handles validation error display and control re-enablement
 * 
 * @param err The HTTP error response
 * @param validationErrorsSignal Signal to update with error messages
 * @param control Optional form control to re-enable on error
 * @param autoClearMs Optional milliseconds to auto-clear errors (default: 5000)
 */
export function handleValidationError(
    err: any,
    validationErrorsSignal: WritableSignal<string[]>,
    control?: AbstractControl | null,
    autoClearMs: number = 5000
): void {
    console.error('❌ Update failed:', err);

    const errors = extractValidationErrors(err);
    validationErrorsSignal.set(errors);

    // Re-enable the control so user can correct the value
    if (control) {
        control.enable({ emitEvent: false });
    }

    // Clear errors after specified time
    if (autoClearMs > 0) {
        setTimeout(() => {
            validationErrorsSignal.set([]);
        }, autoClearMs);
    }
}
